import { render, staticRenderFns } from "./Kaart.vue?vue&type=template&id=ed1754b0&scoped=true&"
import script from "./Kaart.vue?vue&type=script&lang=js&"
export * from "./Kaart.vue?vue&type=script&lang=js&"
import style0 from "./Kaart.vue?vue&type=style&index=0&id=ed1754b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1754b0",
  null
  
)

export default component.exports